import React from 'react';
import { RadioGroup, RadioGroupProps } from '@mui/material';

const DSRadioGroup: React.FC<RadioGroupProps> = (props) => {
  return <RadioGroup {...props} />;
};

export default DSRadioGroup;
